"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("../../../../styles/colors");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    background-color: transparent;\n    height: 100vh;\n    position: absolute;\n    right: 0;\n    width: 1px;\n\n    :hover {\n        background-color: ", ";\n    }\n\n    :active {\n        background-color: ", ";\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledGuideline = _styledComponents["default"].span(_templateObject(), _colors.COLOR_BRAND, _colors.COLOR_BRAND_ACTIVE);

var _default = StyledGuideline;
exports["default"] = _default;